export enum ModalModeType {
    EDIT = 'edit',
    CREATE = 'create',
    READ_ONLY = 'readonly',
    SELECT_TRANSPARENT_ADMINISTRATION = 'select_transparent_administration',
    SELECT_NOTICES = 'select_notices'
}
